export class FiltrosSolicitudes{

    TipoDocumentoIdentidad: number = 0;
    NroDocumentoIdentidad = '';
    Codigo = '';
    
}